import fetch from 'utils/fetch'
import { cgiCallWrapper } from 'utils/cgiCallWrapper'
import { removeSuffix } from './index'

/**
 * 分片上传
 * @param {*} params
 */
export const uploadBySlice = params => {
    return fetch({
        url: '/channel/slice',
        method: 'POST',
        data: params,
    })
}

/**
 * 上传单个渠道包
 *  @param {object} {
        appId: number;
        channelApk: UploadApkInfo;
    }
    interface UploadApkInfo {
        channelName: string;        // 渠道包名
        channelKey: string;         // 渠道包唯一标识, 新增渠道包时填空
        url: string;                // 文件下载地址, 选填
    }
    @return {array} Array<UploadApkResult>
    interface UploadApkResult {
        channelName: string;        // 渠道包名
        channelKey: string;         // 渠道包唯一标识
        ret: number;                // 0成功, <0失败
        msg: string;                // 失败时原因描述
    }
 */
export const singleUpload = params => {
    return fetch({
        url: '/upload/single',
        method: 'POST',
        data: params,
    })
}

/**
 * 批量添加任务
 * @param {*} params
 */
export const batchUpload = params => {
    return fetch({
        url: '/upload/batch',
        method: 'POST',
        data: params,
    })
}

export const parseBatchUploadFile = params => {
    return fetch({
        url: '/channel/parse_batch_upload_file',
        method: 'POST',
        opts: {
            headers: {
                'Content-Type': 'multipart/form-data;charset=UTF-8',
            },
        },
        data: params,
    })
}

/**
 * @desc 批量查询同名渠道包是否已存在, 存在时IsExistRsp::channelInfo会返回简要的渠道包信息
 * @param { appId: number, name: Array<string> }  // name数组限制[1, 1024], name[1, 128]
 * @return { c: number, d: string, b?: Array<IsExistRsp> }
 * interface ChannelInfoLight {
    appId: number;              // APP ID
    channelId: string;          // 渠道号
    channelName: string;        // 渠道包名
    channelKey: string;         // 渠道包唯一标识
    versionName: string;        // 版本名
    versionCode: number;        // 版本号
}

    interface IsExistRsp {
        ret: number;                // 200存在, channelInfo返回简要渠道包信息; ret=404不存在
        name: string;               // 渠道包名
        channelInfo?: ChannelInfoLight; 
    }
 */
export const checkNameExists = params => {
    return fetch({
        url: '/channel/isexist',
        method: 'POST',
        data: params,
    })
}

/****************** functions dealing with network callback *****************/
/**
 * 创建渠道包处理任务
 * @param {array} list 渠道包列表
 */
export const addUploadTask = async (appId, list, isSingle = false) => {
    let uploadAPI = null
    const params = {
        appId,
    }
    // 单个任务
    if (isSingle) {
        uploadAPI = singleUpload
        params.channelApk = list[0]
        // 批量任务
    } else {
        uploadAPI = batchUpload
        params.channelApk = list
    }
    const res = await cgiCallWrapper(uploadAPI, params)
    return addUploadTaskResponseProcess({ res, channelApk: list, isSingle })
}

export const addUploadTaskResponseProcess = ({ res, channelApk, isSingle = false }) => {
    if (!res) return null

    let successRecords = []
    let failedRecords = []

    if (res.c === 200) {
        // 接口调用成功
        if (res.b && res.b.length > 0) {
            res.b.forEach(item => {
                if (item.ret === 200) {
                    successRecords.push(item)
                } else {
                    failedRecords.push(item)
                }
            })
        } else if (isSingle) {
            if (res.b.ret === 200) {
                successRecords.push(res.b)
            } else {
                failedRecords.push(res.b)
            }
        }
    } else if (Array.isArray(channelApk)) {
        // 上传失败
        channelApk.forEach(apk => {
            apk.channelKey = ''
            apk.ret = res.c
            apk.msg = res.d
            failedRecords.push(apk)
        })
    }
    return { successRecords, failedRecords }
}

// 检查渠道包名称重复的情况
export const checkNamesExistCall = async (pkgList = {}, appId) => {
    // 渠道包名称是否存在的时候，传的参数要去掉 包体位数后缀
    const allNames = Object.keys(pkgList).map(name => removeSuffix(name))
    const names = Array.from(new Set(allNames)) // 去重渠道包名称
    const params = {
        appId,
        name: names,
    }
    const res = await cgiCallWrapper(checkNameExists, params)
    return checkNamesExistCallResponseProcess(pkgList, res)
}

export const checkNamesExistCallResponseProcess = (pkgList, res) => {
    const exist = {}
    const notExist = {}
    const channelInfosByName = {}

    if (res && res.b && res.b.length > 0) {
        res.b.forEach(item => {
            // 从后台查询回来的列表，channelName 是不带 包体位数后缀的
            if (item.ret === 200) {
                channelInfosByName[item.name] = item.channelInfo
            }
        })
    }

    Object.values(pkgList).forEach(pkg => {
        const name = removeSuffix(pkg.channelName)
        if (channelInfosByName[name]) {
            exist[pkg.channelName] = Object.assign(pkg, channelInfosByName[name])
        } else {
            notExist[pkg.channelName] = pkg
        }
    })

    return { exist, notExist }
}

export const parseBatchUploadFileCall = async file => {
    const params = new FormData()
    params.append('file', file[0])
    const res = await cgiCallWrapper(parseBatchUploadFile, params)
    return parseBatchUploadFileCallResponseProcess(res)
}

export const parseBatchUploadFileCallResponseProcess = res => {
    if (res && res.b && res.b.length > 0) {
        let result = {}

        res.b.forEach(item => {
            result[item.name] = {
                channelName: item.name,
                value: item.url,
                type: 'url',
            }
        })
        return result
    }
    return null
}
